export const CANCEL_SCHEDULE_TASKS = "CANCEL_SCHEDULE_TASKS";
export const CANCEL_SCHEDULE_TASKS_SUCCESS = "CANCEL_SCHEDULE_TASKS_SUCCESS";
export const CANCEL_SCHEDULE_TASKS_ERROR = "CANCEL_SCHEDULE_TASKS_ERROR";
export const RESET_CANCEL_SCHEDULE_TASKS = "RESET_CANCEL_SCHEDULE_TASKS";

export interface CancelScheduleTasks {
  type: typeof CANCEL_SCHEDULE_TASKS;
  payload: number[]; // Array de IDs de schedule tasks a cancelar
}

export interface CancelScheduleTasksSuccess {
  type: typeof CANCEL_SCHEDULE_TASKS_SUCCESS;
  payload: any;
}

export interface CancelScheduleTasksError {
  type: typeof CANCEL_SCHEDULE_TASKS_ERROR;
  payload: boolean | string;
}

export interface ResetCancelScheduleTasks {
  type: typeof RESET_CANCEL_SCHEDULE_TASKS;
  payload: null;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | CancelScheduleTasks
  | CancelScheduleTasksSuccess
  | CancelScheduleTasksError
  | ResetCancelScheduleTasks;

